import React, { useState } from "react";
import { useGetSimulabOperacionesQuery } from "../../libs/redux/slices/Simulab/simulabApiSlice";

/**
 * Paso 0 del simulador: escribir o elegir el DO. La lista sugiere las importaciones recientes que coinciden con lo
 * escrito (número del DO o nombre del cliente).
 * @param {object} props
 * @param {string} props.docnroxx DO en uso
 * @param {Function} props.onElegir Recibe el DO elegido
 * @author Claude Code (Alexandra Parra) <direccionit.siaco@repremundo.com.co>
 * @since 2026-10-26
 */
const Elegirdo = ({ docnroxx, onElegir }) => {
  const [texto, setTexto] = useState(docnroxx);
  const { data } = useGetSimulabOperacionesQuery({ BUSCARXX: texto.trim() });
  const opciones = data?.data ?? [];
  /**
   * Usa el DO escrito (o el primero de la lista si se escribió un cliente).
   * @param {Event} evento Envío del formulario
   */
  const usar = (evento) => {
    evento.preventDefault();
    const cDo = /^\d{8,10}$/.test(texto.trim()) ? texto.trim() : String(opciones[0]?.DOCNROXX ?? "");
    if (cDo) {
      setTexto(cDo);
      onElegir(cDo);
    }
  };
  return (
    <form className="rio-card rio-form sim-do" onSubmit={usar}>
      <label className="rio-field">
        Operación (DO) con que vas a probar
        <input list="sim-operaciones" value={texto} onChange={(e) => setTexto(e.target.value)} placeholder="Escribe el DO o el cliente" />
      </label>
      <datalist id="sim-operaciones">
        {opciones.map((m) => (
          <option key={m.DOCNROXX} value={m.DOCNROXX}>{`${m.CLINOMXX ?? ""} · ${m.SUCIDXXX ?? ""} · ${m.DOCETAPA ?? ""}`}</option>
        ))}
      </datalist>
      <button type="submit" className="sim-boton principal">Usar este DO</button>
      <span className="sim-quien">{docnroxx ? `Probando con el DO ${docnroxx}` : "Elige una importación para empezar"}</span>
    </form>
  );
};

export default Elegirdo;
